import log from "loglevel";
import { getCurrentUserToken } from "./index";
import envconfig from "../envconfig";
class FileService {
    loadFile = ( url) => {
        return new Promise((resolve => {
            const xhr = new XMLHttpRequest();
            const _token = getCurrentUserToken();
            const _url = envconfig.api + url;
            xhr.open("GET", _url);
            xhr.onreadystatechange = handler;
            xhr.responseType = "blob";
            if (_token) {
                xhr.setRequestHeader("Authorization", "Bearer " + _token);
            } else { 
                xhr.withCredentials = true;
            }
            xhr.send();

            function handler() {
                if (this.readyState === this.DONE) {
                    if (this.status === 200) {
                        if(!this.response || this.response.size === 0) {
                            resolve(null);

                        }
                        
                        
                        const data_url = URL.createObjectURL(this.response);
                        resolve(data_url);
                        
                    } else {
                        log.error("Unable to load file for url: ", _url);
                    }
                }
            }
        }) );

    };
}

export default new FileService();
